import classNames from 'classnames';
import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useCloudinary } from '../../hooks/use-cloudinary';
import { layoutDefaults } from '../../utils/layout-defaults';
import { ProductImagePlaceholder } from '../product-image-placeholder';

const animate = 'animate__animated animate__fadeIn';

function SuggestionImage({ suggestion, onClick }) {
  const [smallImageLoaded, setSmallImageLoaded] = useState(false);
  const [selected, setSelected] = useState(false);
  const { transform } = useCloudinary();
  const classes = useStyles({ selected });

  async function handleCLick() {
    setSelected(true);
    onClick?.call(this);
  }

  return (
    <div className={classes.container} onClick={handleCLick} aria-hidden>
      {!smallImageLoaded && <ProductImagePlaceholder absolute />}
      <img
        src={transform(suggestion?.item?.image?.url, 3)}
        alt=""
        className={classNames(classes.smallImage, animate)}
        onLoad={() => setSmallImageLoaded(true)}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',

    width: '35vw',
    height: '35vw',

    maxWidth: '160px',
    maxHeight: '160px',

    // maxWidth: 150,
    // maxHeight: 150,

    backgroundColor: layoutDefaults.imagePlaceholderColor,
    cursor: 'pointer',

    overflow: 'hidden',
    borderRadius: layoutDefaults.radius,

    opacity: ({ selected }) => selected && layoutDefaults.opacity,
    border: `.6px solid #a8a8a8`,
  },
  smallImage: {
    width: '100%',
    height: '100%',
  },
});

export { SuggestionImage };
